"use client"

import React, {useRef} from 'react';
import cx from "clsx";
import {BackgroundImage, Button} from "@mantine/core";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {IArticleListForm} from "@/form/article";
import "./CustomDots.css";
import {IconChevronLeft, IconChevronRight, IconCircleArrowRightFilled} from '@tabler/icons-react';
import '@mantine/carousel/styles.css';
import {Carousel} from "@mantine/carousel";
import Autoplay from "embla-carousel-autoplay";

interface IProps {
    carouselList: IArticleListForm[];
}

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700', '800'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const HomeCarouselLg: React.FC<IProps> = ( { carouselList } ) => {
    const { fontSize, lang } = useGlobalStateStore();
    const autoplay = useRef(Autoplay({ delay: 5000 }));
    return (
        <Carousel loop
                  plugins={[autoplay.current]}
                  onMouseEnter={autoplay.current.stop}
                  onMouseLeave={autoplay.current.reset}
                  nextControlIcon={<IconChevronRight size={30} color="white" />}
                  previousControlIcon={<IconChevronLeft size={30} color="white"/>}
        >
            {
                carouselList.map((item, index) => (
                    <Carousel.Slide>
                        <BackgroundImage key={`carousel2-${index}`}
                                         src={`${process.env.NEXT_PUBLIC_API_HOST}/image/${item.bannerArhId?.arhId}`} className="h-[80vh]" >
                            <div className="max-w-[1250px] mx-auto relative">
                                <div className={cx("absolute left-[3%] leading-[24px] bg-black bg-opacity-40 transition text-[0.9em] max-w-[600px] pb-[15px] w-[65%] px-[20px] pt-[10px] top-[20vh]"
                                )}>
                                    <div className={cx("font-extrabold mt-[10px] text-white text-[22px] leading-[31px] mb-[15px]", notoSansTC.className)}>
                                        {lang == "tw" ? item.titleC : item.titleE}
                                    </div>
                                    <div className={cx("text-[#dad9d9] text-[15px] font-medium line-clamp-2", notoSansTC.className)}>
                                        {item.summary}
                                    </div>
                                    <div className="pt-3">
                                        <Button color={"#a75943"}
                                                component={"a"}
                                                href={item.category == "LINK" ? ( lang == "tw" ? item.linkUrl!! : item.linkUrlE!! ) : `/news/detail/${item.artId}`}
                                                target={item.category == "LINK" ? '_blank' : '_parent'}
                                                rightSection={<IconCircleArrowRightFilled size={18}/>} py={3} radius={2}>{lang == "tw" ? "了解更多" : "More"}</Button>
                                    </div>
                                </div>
                            </div>
                        </BackgroundImage>
                    </Carousel.Slide>
                ))
            }
        </Carousel>
    );
}

export default HomeCarouselLg;